import React from 'react';
import { Hexagon } from 'lucide-react';
import { BoxProps } from '@mantine/core';
import { IconWrapper } from './IconWrapper';

interface RadarChartIconProps extends BoxProps {
    size?: number;
    color?: string;
}

export const RadarChartIcon: React.FC<RadarChartIconProps> = ({ size = 32, color, ...props }) => {
    return (
        <IconWrapper size={size} {...props}>
            <Hexagon size={size} color={color} />
        </IconWrapper>
    );
};
